import { render, staticRenderFns } from "./GraficaReporteGeneral.vue?vue&type=template&id=71fa4a18&scoped=true&"
import script from "./GraficaReporteGeneral.vue?vue&type=script&lang=js&"
export * from "./GraficaReporteGeneral.vue?vue&type=script&lang=js&"
import style0 from "./GraficaReporteGeneral.vue?vue&type=style&index=0&id=71fa4a18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71fa4a18",
  null
  
)

export default component.exports